import React, { useEffect } from 'react';

const GiftCancelled = () => {
  useEffect(() => {
    // Clear any stored gift data since the purchase was cancelled
    localStorage.removeItem('pendingGift');
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-sky-50 to-blue-100 flex items-center justify-center">
      <div className="text-center max-w-md mx-auto p-6">
        <div className="text-sky-500 text-6xl mb-4">❌</div>
        <h1 className="text-3xl font-bold text-gray-800 mb-4">Gift Purchase Cancelled</h1>
        <p className="text-gray-600 mb-6">
          Your gift purchase was cancelled. No charges were made to your account.
        </p>
        <div className="bg-white rounded-lg p-4 mb-6 shadow-sm border border-sky-100">
          <p className="text-sm text-gray-500 mb-2">Need help?</p>
          <ul className="text-sm text-gray-600 text-left space-y-1">
            <li>• Contact us if you have any questions</li>
            <li>• You can try purchasing again anytime</li>
            <li>• Check our FAQ for common issues</li>
          </ul>
        </div>
        <div className="space-y-3">
          <a
            href="/"
            className="inline-block bg-gradient-to-r from-sky-600 to-blue-600 text-white px-6 py-3 rounded-lg hover:from-sky-700 hover:to-blue-700 transition-colors w-full"
          >
            Return to Home
          </a>
          <a
            href="/contact"
            className="inline-block bg-gray-200 text-gray-800 px-6 py-3 rounded-lg hover:bg-gray-300 transition-colors w-full"
          >
            Contact Support
          </a>
        </div>
      </div>
    </div>
  );
};

export default GiftCancelled; 